/* eslint-disable no-underscore-dangle */
import React from 'react';

import { AdyenChangePaymentMethodForm } from './providers/Adyen';

export const ChangePaymentMethodForm = ({ ...props }) => {
  return <AdyenChangePaymentMethodForm {...props} />;
};
